export default __webpack_public_path__ + "static/media/sch5_w320.c6d145ee.jpg";